/* =========================================
   TEEINBLUE STICKY (CONCEPT / HalloGeschenk.de)
   Mobile portrait only • Portal + Placeholder • Zoom 100–200% • Pan Up/Down
   Nur Teeinblue-Produkte mit SKU 263
   Auto-Open beim Scrollen nach unten • Auto-Close beim Scrollen nach oben
   Manuelles Schließen via X • Wiedereinblenden via Zoom-Button
   ========================================= */

document.addEventListener("DOMContentLoaded", () => {
  const galleryWrapperSelector = ".product__gallery";

  // Hysterese: Öffnen erst wenn deutlich runtergescrollt,
  // Schließen schon wenn Galerie fast wieder im Blick ist
  const OPEN_TRIGGER_RATIO = 1.5;   // rect.top < -innerHeight * 1.5  → öffnen
  const CLOSE_TRIGGER_RATIO = 0.3;  // rect.top > -innerHeight * 0.3  → schließen

  const PRODUCT_HANDLE =
    window.location.pathname.split("/products/")[1]?.split("?")[0]?.split("/")[0] || "unknown";

  const SCALE_KEY = "hgde_hallo_sticky_preview_scale_step_v1";
  const PAN_KEY = "hgde_hallo_sticky_preview_pan_y_v1";

  // Mobile portrait only
  const w = window.innerWidth;
  const h = window.innerHeight;
  const isMobilePortrait = h / w > 1.5 && w < 768;
  if (!isMobilePortrait) return;

  const $gallery = document.querySelector(galleryWrapperSelector);
  if (!$gallery) return;

  // Nur Teeinblue Produkte
  const HGDE_PRODUCT_SKUS =
    window.HGDE_PRODUCT_SKUS ||
    (window.json_product && window.json_product.variants
      ? window.json_product.variants.map((variant) => variant.sku)
      : []);

  const isTeeinblueProduct = HGDE_PRODUCT_SKUS.some((sku) => {
    const cleanSku = String(sku || "").trim();
    return cleanSku.startsWith("263") || cleanSku.includes("263");
  });

  if (!isTeeinblueProduct) return;

  // ===== CONFIG =====
  const SCALE_STEPS = [1.0, 1.25, 1.5, 1.75, 2.0];
  const DEFAULT_STEP_INDEX = 0;

  // [NEU] Größe der Sticky-Vorschau in % der Bildschirmbreite.
  // Das Bild ist 1:1 → dieser Wert bestimmt zugleich die Höhe der Leiste.
  // Je kleiner, desto mehr Platz bleibt unten fürs Personalisieren.
  // 100 = wie bisher (volle Breite), 70 = ca. ein Drittel weniger Höhe.
  const STICKY_SIZE_PCT = 70;

  const PAN_STEP_PX = 24;
  const PAN_MAX_ABS_PX = 260;

  const PANEL_LEFT_PX = 10;

  const PADDING_TOP = 0;
  const PADDING_BOTTOM = 0;

  const REMEASURE_THRESHOLD_PX = 10;

  // ===== STATE =====
  let isStickyOpen = false;
  // Suppress-Flag: wenn User manuell mit X geschlossen hat ODER
  // Auto-Close ausgelöst wurde, blockieren wir Auto-Open bis Galerie
  // wieder hoch genug gescrollt wurde (rect.top > closePoint).
  let suppressAutoOpen = false;

  let portal = null;
  let hint = null;
  let hintTimer = null;
  let stickyBtn = null;
  let closeBtn = null;

  let scalePanel = null;
  let minusBtn = null;
  let plusBtn = null;
  let stepLabel = null;

  let upBtn = null;
  let downBtn = null;

  let movedNode = null;
  let originalParent = null;
  let originalNext = null;

  let placeholder = null;
  let wrapper = null;
  let lastMeasuredH = 0;

  // [NEU] gesicherte Scrollpositionen des Sliders für das Umhängen
  let pendingSnap = [];

  const qs = (sel, root = document) => root.querySelector(sel);

  const getGalleryContent = () =>
    qs(`${galleryWrapperSelector} .tee-gallery-content`) || qs(".tee-gallery-content");

  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

  const loadStepIndex = () => {
    const raw = sessionStorage.getItem(SCALE_KEY);
    const n = raw == null ? DEFAULT_STEP_INDEX : parseInt(raw, 10);
    if (Number.isNaN(n)) return DEFAULT_STEP_INDEX;
    return clamp(n, 0, SCALE_STEPS.length - 1);
  };

  let scaleStepIndex = loadStepIndex();

  const setScaleVar = (val) => {
    document.documentElement.style.setProperty("--hgdeStickyScale", String(val));
  };

  const loadPanY = () => {
    const raw = sessionStorage.getItem(PAN_KEY);
    const n = raw == null ? 0 : parseInt(raw, 10);
    if (Number.isNaN(n)) return 0;
    return clamp(n, -PAN_MAX_ABS_PX, PAN_MAX_ABS_PX);
  };

  let panY = loadPanY();

  const setPanVar = (val) => {
    document.documentElement.style.setProperty("--hgdeStickyPanY", `${val}px`);
  };

  const updateScaleUi = () => {
    const val = SCALE_STEPS[scaleStepIndex];
    if (stepLabel) stepLabel.textContent = `${Math.round(val * 100)}%`;
    if (minusBtn) minusBtn.style.opacity = scaleStepIndex === 0 ? "0.35" : "1";
    if (plusBtn) plusBtn.style.opacity = scaleStepIndex === SCALE_STEPS.length - 1 ? "0.35" : "1";
  };

  // [GEÄNDERT] kein await/kein Neumessen des Platzhalters mehr –
  // Zoom verändert nur noch den Transform, nie das Seitenlayout.
  const applyScaleStep = (delta) => {
    const next = clamp(scaleStepIndex + delta, 0, SCALE_STEPS.length - 1);
    if (next === scaleStepIndex) return;

    scaleStepIndex = next;
    sessionStorage.setItem(SCALE_KEY, String(scaleStepIndex));

    setScaleVar(SCALE_STEPS[scaleStepIndex]);
    updateScaleUi();

    // Pan nachziehen, falls der neue Zoom weniger Spielraum lässt
    const maxAbs = clampPanByViewport();
    const clamped = clamp(panY, -maxAbs, maxAbs);
    if (clamped !== panY) {
      panY = clamped;
      sessionStorage.setItem(PAN_KEY, String(panY));
      setPanVar(panY);
    }

    updatePanUi();
  };

  // [GEÄNDERT] Der Rahmen hat jetzt eine feste Höhe und das Bild passt
  // bei 100% exakt hinein. Überstand entsteht nur durch Zoom und liegt
  // wegen transform-origin:top unten → rein rechnerisch, keine Messung.
  const clampPanByViewport = () => {
    const box = movedNode || null;
    if (!box) return PAN_MAX_ABS_PX;

    const frameH = box.getBoundingClientRect().height || 0;
    if (!frameH) return PAN_MAX_ABS_PX;

    const overflow = frameH * (SCALE_STEPS[scaleStepIndex] - 1);
    return clamp(Math.round(overflow), 0, PAN_MAX_ABS_PX);
  };

  // [NEU] Bei 100% gibt es nichts zu verschieben → Pfeile abblenden,
  // damit keine toten Buttons dastehen.
  const updatePanUi = () => {
    const maxAbs = clampPanByViewport();
    if (upBtn) upBtn.style.opacity = maxAbs === 0 || panY <= -maxAbs ? "0.35" : "1";
    if (downBtn) downBtn.style.opacity = maxAbs === 0 || panY >= maxAbs ? "0.35" : "1";
  };

  // [GEÄNDERT] kein await/kein Neumessen des Platzhalters mehr
  const applyPan = (deltaPx) => {
    const maxAbs = clampPanByViewport();
    const next = clamp(panY + deltaPx, -maxAbs, maxAbs);
    if (next === panY) return;

    panY = next;
    sessionStorage.setItem(PAN_KEY, String(panY));
    setPanVar(panY);

    updatePanUi();
  };

  setScaleVar(SCALE_STEPS[scaleStepIndex]);
  setPanVar(panY);

  const zoomBg = `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M114.5,79.1C95,79.1,79.1,95,79.1,114.5v283c0,19.5,15.8,35.4,35.4,35.4h283c19.5,0,35.4-15.8,35.4-35.4v-283c0-19.5-15.8-35.4-35.4-35.4H114.5z M114.5,409.3c-6.5,0-11.8-5.3-11.8-11.8V308l94.3-94.3l195.6,195.6H114.5z M409.3,392.7L331.6,315l30.5-30.5l47.2,47.2V392.7z M409.3,114.5v183.8l-38.8-38.9c-4.6-4.6-12.1-4.7-16.7-0.1L315,298.3L205.4,188.7c-4.6-4.6-12.1-4.7-16.7-0.1l-86,86.1V114.5c0-6.5,5.3-11.8,11.8-11.8h283c6.5,0,11.8,5.3,11.8,11.8z"/><path d="M326.7,138.1c-26,0-47.2,21.1-47.2,47.2s21.1,47.2,47.2,47.2s47.2-21.1,47.2-47.2S352.8,138.1,326.7,138.1z M326.7,208.8c-13,0-23.6-10.6-23.6-23.6s10.6-23.6,23.6-23.6s23.6,10.6,23.6,23.6-10.6,23.6-23.6,23.6z"/></svg>')`;

  const closeSvg = `<svg viewBox="0 0 329 329" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M194.8 164.77l128.21-128.21c8.34-8.34 8.34-21.82 0-30.16-8.34-8.34-21.82-8.34-30.16 0L164.64 134.6 36.43 6.39c-8.34-8.34-21.82-8.34-30.16 0-8.34 8.34-8.34 21.82 0 30.16l128.21 128.21L6.27 292.98c-8.34 8.34-8.34 21.82 0 30.16 4.16 4.16 9.62 6.25 15.08 6.25s10.92-2.09 15.08-6.25l128.21-128.21 128.21 128.21c4.16 4.16 9.62 6.25 15.08 6.25s10.92-2.09 15.08-6.25c8.34-8.34 8.34-21.82 0-30.16z"/></svg>`;

  const injectStyles = () => {
    const style = document.createElement("style");
    style.textContent = `
      :root{
        --hgdeStickyScale: ${SCALE_STEPS[scaleStepIndex]};
        --hgdeStickyPanY: ${panY}px;
        /* [NEU] Kantenlänge der quadratischen Vorschau */
        --hgdeStickySize: ${STICKY_SIZE_PCT}vw;
        /* [NEU] Grundskalierung. Das Layout bleibt bei voller Breite
           (sonst reißt es den Slider auseinander), verkleinert wird
           ausschließlich optisch über den Transform. */
        --hgdeStickyFit: ${STICKY_SIZE_PCT / 100};
      }

      #hgde-sticky-portal{
        position: fixed;
        inset: 0;
        width: 100vw;
        height: 0;
        z-index: 2147483647;
        pointer-events: none;
      }

      .hgde-sticky-placeholder{
        width: 100%;
        height: 0px;
      }

      body.gallery--sticky #hgde-sticky-portal .tee-gallery-content{
        pointer-events: auto;
        position: fixed;
        top: env(safe-area-inset-top, 0px);
        left: 0;
        right: 0;
        width: 100%;
        /* [NEU] feste Höhe statt Inhaltshöhe – dadurch steht der Rahmen
           sofort, unabhängig davon ob das Bild schon geladen ist.
           !important, weil der Slider dem Container eine Höhe per
           Inline-Style verpasst; ohne das bleibt die weiße Fläche hoch,
           obwohl das Bild schon verkleinert ist. */
        height: calc(var(--hgdeStickySize) + ${PADDING_TOP}px + ${PADDING_BOTTOM}px) !important;
        min-height: 0 !important;
        max-height: calc(var(--hgdeStickySize) + ${PADDING_TOP}px + ${PADDING_BOTTOM}px) !important;
        box-sizing: border-box;
        padding: ${PADDING_TOP}px 0 ${PADDING_BOTTOM}px 0;
        background: #fff;
        box-shadow: 0 10px 35px rgba(0,0,0,.25);
        display: flex;
        justify-content: center;
        align-items: flex-start;
        overflow: hidden;
        transform: translateZ(0);
      }

      body.gallery--sticky #hgde-sticky-portal .hgde-sticky-scale{
        display: block;
        /* Layoutbreite bleibt voll – der Slider rechnet intern mit
           Pixelbreiten, ein schmalerer Kasten würde ihn nur nach rechts
           schieben statt ihn zu verkleinern. */
        width: 100%;
        /* [GEÄNDERT] Verkleinert wird rein optisch: Grundskalierung mal
           Zoomstufe. Bei 1:1 wird aus 100vw Höhe damit exakt
           STICKY_SIZE_PCT vw – genau die Höhe des Rahmens. */
        transform: translateY(var(--hgdeStickyPanY))
                   scale(calc(var(--hgdeStickyFit) * var(--hgdeStickyScale)));
        transform-origin: top center;
        will-change: transform;
      }

      body.gallery--sticky #hgde-sticky-portal .tee-thumbnails,
      body.gallery--sticky #hgde-sticky-portal .tee-slider__dots{
        display: none !important;
      }

      body.gallery--sticky #hgde-sticky-portal .tee-gallery-content{
        touch-action: pan-y !important;
        overscroll-behavior: contain;
      }

      .sticky-gallery-button{
        background-color: #fff;
        background-position: center;
        background-repeat: no-repeat;
        background-size: 20px 20px;
        border-radius: 50%;
        box-shadow: 0 4px 14px rgba(0,0,0,.2);
        display: none;
        height: 44px;
        width: 44px;
        position: fixed;
        right: 16px;
        top: calc(env(safe-area-inset-top, 0px) + 96px);
        z-index: 2147483647;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
      }

      body.gallery--sticky-ready .sticky-gallery-button{
        display: block;
      }

      body.gallery--sticky .sticky-gallery-button{
        display: none !important;
      }

      .sticky-gallery-button::after{
        content: "Zoom";
        position: absolute;
        top: 48px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 11px;
        line-height: 1;
        color: rgba(0,0,0,.55);
        white-space: nowrap;
        pointer-events: none;
      }

      .hgde-sticky-close{
        position: fixed;
        right: 14px;
        top: calc(env(safe-area-inset-top, 0px) + 14px);
        width: 44px;
        height: 44px;
        border-radius: 999px;
        background: rgba(255,255,255,.92);
        box-shadow: 0 6px 18px rgba(0,0,0,.18);
        display: none;
        align-items: center;
        justify-content: center;
        pointer-events: auto;
        z-index: 2147483647;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
        user-select: none;
      }

      body.gallery--sticky .hgde-sticky-close{
        display: flex;
      }

      .hgde-sticky-close svg{
        width: 18px;
        height: 18px;
        opacity: .65;
      }

      .hgde-sticky-hint{
        position: fixed;
        right: 16px;
        top: calc(env(safe-area-inset-top, 0px) + 148px);
        z-index: 2147483647;
        background: rgba(0,0,0,.78);
        color: #fff;
        padding: 8px 10px;
        border-radius: 999px;
        font-size: 12px;
        line-height: 1;
        display: none;
        max-width: 70vw;
        pointer-events: none;
      }

      .hgde-sticky-hint.show{
        display: inline-flex;
      }

      .hgde-sticky-scale-panel{
        position: fixed;
        left: ${PANEL_LEFT_PX}px;
        top: calc(env(safe-area-inset-top, 0px) + 14px);
        z-index: 2147483647;
        display: none;
        flex-direction: column;
        gap: 8px;
        align-items: center;
        pointer-events: auto;
        user-select: none;
        -webkit-tap-highlight-color: transparent;
      }

      body.gallery--sticky .hgde-sticky-scale-panel{
        display: flex;
      }

      .hgde-sticky-scale-btn{
        width: 42px;
        height: 42px;
        border-radius: 999px;
        background: rgba(255,255,255,.92);
        box-shadow: 0 6px 18px rgba(0,0,0,.18);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        line-height: 1;
        color: rgba(0,0,0,.72);
        cursor: pointer;
      }

      .hgde-sticky-scale-label{
        height: 36px;
        padding: 0 10px;
        border-radius: 999px;
        background: rgba(255,255,255,.92);
        box-shadow: 0 6px 18px rgba(0,0,0,.18);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        color: rgba(0,0,0,.6);
        min-width: 64px;
      }
    `;
    document.head.appendChild(style);
  };

  const showHint = (ms = 2200) => {
    if (!hint) return;
    hint.classList.add("show");
    if (hintTimer) clearTimeout(hintTimer);
    hintTimer = setTimeout(() => {
      hint.classList.remove("show");
      hintTimer = null;
    }, ms);
  };

  const ensureDom = () => {
    if (!portal) {
      portal = document.createElement("div");
      portal.id = "hgde-sticky-portal";
      document.body.appendChild(portal);

      const blockMultiTouch = (e) => {
        if (!document.body.classList.contains("gallery--sticky")) return;
        if (!portal.contains(e.target)) return;
        if (e.touches && e.touches.length > 1) e.preventDefault();
      };

      portal.addEventListener("touchstart", blockMultiTouch, { passive: false, capture: true });
      portal.addEventListener("touchmove", blockMultiTouch, { passive: false, capture: true });
    }

    if (!hint) {
      hint = document.createElement("div");
      hint.className = "hgde-sticky-hint";
      hint.textContent = 'Klicke “Zoom” für die Live-Vorschau.';
      document.body.appendChild(hint);
    }

    if (!stickyBtn) {
      stickyBtn = document.createElement("div");
      stickyBtn.className = "sticky-gallery-button";
      stickyBtn.style.backgroundImage = zoomBg;

      stickyBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        // Manueller Open hebt die Auto-Open-Sperre auf
        suppressAutoOpen = false;
        openSticky();
      });

      document.body.appendChild(stickyBtn);
    }

    if (!closeBtn) {
      closeBtn = document.createElement("div");
      closeBtn.className = "hgde-sticky-close";
      closeBtn.setAttribute("role", "button");
      closeBtn.setAttribute("aria-label", "Close preview");
      closeBtn.innerHTML = closeSvg;

      closeBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        // User schließt manuell → kein Auto-Open mehr, bis hochgescrollt wurde
        suppressAutoOpen = true;
        closeSticky();
        showHint();
      });

      document.body.appendChild(closeBtn);
    }

    if (!scalePanel) {
      scalePanel = document.createElement("div");
      scalePanel.className = "hgde-sticky-scale-panel";

      plusBtn = document.createElement("div");
      plusBtn.className = "hgde-sticky-scale-btn";
      plusBtn.setAttribute("role", "button");
      plusBtn.setAttribute("aria-label", "Zoom in");
      plusBtn.textContent = "+";
      plusBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        applyScaleStep(+1);
      });

      stepLabel = document.createElement("div");
      stepLabel.className = "hgde-sticky-scale-label";

      minusBtn = document.createElement("div");
      minusBtn.className = "hgde-sticky-scale-btn";
      minusBtn.setAttribute("role", "button");
      minusBtn.setAttribute("aria-label", "Zoom out");
      minusBtn.textContent = "−";
      minusBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        applyScaleStep(-1);
      });

      upBtn = document.createElement("div");
      upBtn.className = "hgde-sticky-scale-btn";
      upBtn.setAttribute("role", "button");
      upBtn.setAttribute("aria-label", "Move up");
      upBtn.textContent = "↑";
      upBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        applyPan(-PAN_STEP_PX);
      });

      downBtn = document.createElement("div");
      downBtn.className = "hgde-sticky-scale-btn";
      downBtn.setAttribute("role", "button");
      downBtn.setAttribute("aria-label", "Move down");
      downBtn.textContent = "↓";
      downBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        applyPan(+PAN_STEP_PX);
      });

      scalePanel.appendChild(plusBtn);
      scalePanel.appendChild(stepLabel);
      scalePanel.appendChild(minusBtn);
      scalePanel.appendChild(upBtn);
      scalePanel.appendChild(downBtn);

      document.body.appendChild(scalePanel);
      updateScaleUi();
    }
  };

  // [GEÄNDERT] Der Platzhalter bekommt seine Höhe jetzt SYNCHRON und aus
  // der Breite (Bild ist 1:1). Vorher: zwei requestAnimationFrame später
  // und aus der gemessenen Höhe – in der Zwischenzeit war die Galerie
  // schon aus dem Fluss, der Platzhalter aber noch 0px hoch. Genau das
  // war der Sprung.
  const ensurePlaceholder = (node) => {
    if (placeholder) return;
    if (!originalParent) return;

    const rect = node.getBoundingClientRect();
    const flowH = Math.round(rect.width > 0 ? rect.width : rect.height);

    placeholder = document.createElement("div");
    placeholder.className = "hgde-sticky-placeholder";
    placeholder.style.height = `${flowH}px`;

    lastMeasuredH = flowH;

    originalParent.insertBefore(placeholder, originalNext);
  };

  const removePlaceholder = () => {
    if (!placeholder) return;
    placeholder.remove();
    placeholder = null;
    lastMeasuredH = 0;
  };

  const wrapForScaling = () => {
    if (!movedNode) return;

    wrapper = movedNode.querySelector(".hgde-sticky-scale");
    if (wrapper) return;

    wrapper = document.createElement("div");
    wrapper.className = "hgde-sticky-scale";

    while (movedNode.firstChild) {
      wrapper.appendChild(movedNode.firstChild);
    }

    movedNode.appendChild(wrapper);
  };

  // [NEU] Slider verlieren beim Umhängen ihre interne Scrollposition –
  // der Slide steht dann leicht daneben, bis der Slider irgendwann von
  // selbst nachrechnet (das war der Ruck nach ein paar Sekunden).
  // Wir sichern die Positionen und setzen sie sofort wieder.
  const snapshotScrollPositions = (node) => {
    const snap = [];

    node.querySelectorAll("*").forEach((el) => {
      const hasX = el.scrollWidth > el.clientWidth + 1;
      const hasY = el.scrollHeight > el.clientHeight + 1;
      if (!hasX && !hasY) return;
      if (el.scrollLeft === 0 && el.scrollTop === 0) return;

      snap.push({ el, left: el.scrollLeft, top: el.scrollTop });
    });

    return snap;
  };

  const restoreScrollPositions = (snap) => {
    snap.forEach(({ el, left, top }) => {
      if (el.scrollLeft !== left) el.scrollLeft = left;
      if (el.scrollTop !== top) el.scrollTop = top;
    });
  };

  // [NEU] Der Slider richtet sich erst aus, wenn ein scroll- oder
  // resize-Event kommt – deshalb sprang das Bild erst zurecht, sobald
  // der Kunde gescrollt hat. Wir feuern beides sofort selbst.
  const nudgeSliderLayout = (snap) => {
    restoreScrollPositions(snap);

    window.dispatchEvent(new Event("resize"));
    window.dispatchEvent(new Event("scroll"));

    requestAnimationFrame(() => {
      restoreScrollPositions(snap);
      window.dispatchEvent(new Event("scroll"));
    });
  };

  const mountToPortal = () => {
    const node = getGalleryContent();
    if (!node) return false;

    if (node.parentElement === portal) {
      movedNode = node;
      return true;
    }

    originalParent = node.parentNode;
    originalNext = node.nextSibling;

    // [GEÄNDERT] Platzhalter steht, BEVOR der Knoten den Fluss verlässt.
    // Beides im selben Frame → die Seite bewegt sich nicht.
    ensurePlaceholder(node);

    pendingSnap = snapshotScrollPositions(node);

    portal.appendChild(node);
    movedNode = node;

    // Der Anstoß passiert bewusst erst in openSticky(), NACHDEM
    // isStickyOpen gesetzt ist – sonst löst das resize-Event unseren
    // eigenen Scroll-Handler aus und openSticky() liefe erneut an.
    return true;
  };

  const restoreFromPortal = () => {
    if (!movedNode || !originalParent) return;

    // [GEÄNDERT] kein unwrapScaling() mehr. Der Wrapper bleibt bestehen,
    // dadurch werden die Bildknoten beim nächsten Öffnen NICHT wieder
    // umgehängt – das war die Ursache für das sichtbare Neuladen.
    // [NEU] auch beim Zurücklegen die Slider-Position sichern.
    // Hier bewusst OHNE scroll-Event: der Handler würde bei
    // isStickyOpen === false sofort wieder öffnen wollen.
    const snap = snapshotScrollPositions(movedNode);

    if (placeholder && placeholder.parentNode === originalParent) {
      originalParent.insertBefore(movedNode, placeholder);
    } else {
      originalParent.insertBefore(movedNode, originalNext);
    }

    restoreScrollPositions(snap);

    removePlaceholder();

    movedNode = null;
    originalParent = null;
    originalNext = null;
  };

  const keepMountedIfRerendered = () => {
    if (!isStickyOpen) return;

    const node = getGalleryContent();
    if (!node) return;

    if (node.parentElement !== portal) {
      portal.appendChild(node);
      movedNode = node;
    } else {
      movedNode = node;
    }

    wrapForScaling();
  };

  const openSticky = () => {
    if (isStickyOpen) return;

    ensureDom();

    // [GEÄNDERT] Klasse VOR dem Umhängen: der Rahmen steht damit schon
    // an der richtigen Stelle, wenn das Bild hineinkommt.
    document.body.classList.add("gallery--sticky");

    if (!mountToPortal()) {
      document.body.classList.remove("gallery--sticky");
      return;
    }

    isStickyOpen = true;

    setScaleVar(SCALE_STEPS[scaleStepIndex]);
    setPanVar(panY);

    wrapForScaling();
    updateScaleUi();
    updatePanUi();

    // [NEU] Erst jetzt anstoßen: isStickyOpen steht, das ausgelöste
    // scroll-Event kann openSticky() also nicht erneut starten.
    nudgeSliderLayout(pendingSnap);
    pendingSnap = [];
  };

  const closeSticky = () => {
    if (!isStickyOpen) return;

    isStickyOpen = false;

    document.body.classList.remove("gallery--sticky");

    // [GEÄNDERT] war setTimeout(…, 80) – die 80ms waren ein zweiter
    // sichtbarer Versatz beim Schließen.
    restoreFromPortal();
  };

  const autoToggleOnScroll = () => {
    const rect = $gallery.getBoundingClientRect();
    const openPoint = -window.innerHeight * OPEN_TRIGGER_RATIO;
    const closePoint = -window.innerHeight * CLOSE_TRIGGER_RATIO;

    if (isStickyOpen) {
      // Hochgescrollt → automatisch schließen (Suppress NICHT setzen,
      // damit es beim nächsten Runterscrollen wieder aufgeht)
      if (rect.top > closePoint) {
        closeSticky();
      }
      return;
    }

    // Sticky ist zu — wenn weit genug hochgescrollt: Suppress aufheben
    if (rect.top > closePoint) {
      suppressAutoOpen = false;
      return;
    }

    // Weit genug runtergescrollt und nicht gesperrt → öffnen
    if (!suppressAutoOpen && rect.top < openPoint) {
      openSticky();
    }
  };

  const onScroll = () => {
    autoToggleOnScroll();

    const galleryTop = $gallery.getBoundingClientRect().top;
    const formBottom = qs("#tee-artwork-form")?.getBoundingClientRect().bottom || 999999;

    if (galleryTop < -10 && formBottom > 200) {
      document.body.classList.add("gallery--sticky-ready");
    } else {
      document.body.classList.remove("gallery--sticky-ready");
    }
  };

const closeStickyAfterImageUpload = () => {
  document.addEventListener(
    "change",
    (e) => {
      const input = e.target;

      if (!input || input.tagName !== "INPUT") return;
      if (input.type !== "file") return;
      if (!input.files || input.files.length === 0) return;

      const hasImageFile = Array.from(input.files).some((file) =>
        String(file.type || "").startsWith("image/")
      );

      if (!hasImageFile) return;

      suppressAutoOpen = true;

      if (isStickyOpen) {
        closeSticky();
      }

      document.body.classList.remove("gallery--sticky-ready");
    },
    true
  );
};
  // ===== INIT =====
  injectStyles();
  ensureDom();
  closeStickyAfterImageUpload();

  const mo = new MutationObserver(() => keepMountedIfRerendered());
  mo.observe($gallery, { childList: true, subtree: true });

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", () => onScroll(), { passive: true });

  setTimeout(() => {
    onScroll();
  }, 1600);
});